import moment from 'moment';

export const dateISOtoDDMMMYYYY = (value: moment.MomentInput, format = 'YYYY-MM-DDTHH:mm:ssZ') =>
  moment(value, format).format('DD-MMM-YYYY').toUpperCase();

export const dateISOtoFullDateAndTime = (value: moment.MomentInput) => moment(value).format('YYYY-MMDD-HHmmss');

export const getDuration = (from: moment.MomentInput, to: moment.MomentInput, format = 'DD-MMM-YYYY') =>
  moment.duration(moment(from, format).diff(moment(to, format))).toISOString();
